(function () {
  async function insertSectionCartDrawer() {
    if (document.querySelector('#CartDrawer .cart-drawer-items-wrapper')) return;

    const cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items');
    if (!cartDrawerItems) return;

    if (cartDrawerItems.classList.contains('is-empty')) return;

    const wrapper = document.createElement('div');
    wrapper.classList.add('cart-drawer-items-wrapper');

    cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems);
    wrapper.appendChild(cartDrawerItems);

    const upsells = document.querySelector('#cart-drawer-upsell-wrapper');
    const swiper = wrapper.querySelector('.swiper5');

    if (swiper && upsells) {
      swiper.insertAdjacentHTML('afterend', upsells.innerHTML);
    }

    if (!document.querySelector('.cart-drawer-upsell-list li')) {
      const upsellBlock = document.querySelector('#cart-drawer-upsell');
      if (upsellBlock) upsellBlock.remove();
    }
  }

  insertSectionCartDrawer();

  /*
  async function insertSectionCartPage() {
    const cartItems = document.querySelector('cart-items');
    if (!cartItems) return;

    const existingUpsells = document.querySelector('#MainContent #cart-drawer-upsell');
    if (existingUpsells) {
      existingUpsells.remove();
    }

    const upsells = document.querySelector('#cart-drawer-upsell-wrapper');
    if (!upsells) return;

    cartItems.querySelector('.page-width').insertAdjacentHTML('beforeend', upsells.innerHTML);

    if (!document.querySelector('.cart-drawer-upsell-list li')) {
      const upsellBlock = document.querySelector('#cart-drawer-upsell');
      if (upsellBlock) upsellBlock.remove();
    }
  }

  insertSectionCartPage();
  */

  window.onChangeKsUpsellVariantSelector = function (select, event) {
    if (event) event.preventDefault();

    const imgSrc = select.options[select.selectedIndex].dataset.variantImg;

    if (imgSrc) {
      console.log(imgSrc);

      const img = select
        .closest('.cart-drawer-upsell-list-item')
        .querySelector('.cart-drawer-upsell-list-item-left img');

      if (img) {
        img.src = imgSrc;
      }
    }
  };

  function listenCartDrawer() {
  const element = document.querySelector('cart-drawer');
  if (!element) return;

  let timer;
  let isUpdating = false;

  const observer = new MutationObserver((mutations) => {
    if (isUpdating) return;

    const shouldIgnore = mutations.every((mutation) => {
      const target = mutation.target;
      return target.closest?.('#cart-drawer-upsell-wrapper') ||
             target.closest?.('.cart-drawer-upsell--injected') ||
             target.id === 'cart-drawer-upsell-wrapper';
    });

    if (shouldIgnore) return;

    if (timer) clearTimeout(timer);

    timer = setTimeout(async () => {
      isUpdating = true;

      try {
        const response = await fetch(window.location.href);
        const text = await response.text();
        const newDocument = new DOMParser().parseFromString(text, 'text/html');

        const currentWrapper = document.querySelector('#cart-drawer-upsell-wrapper');
        const newWrapper = newDocument.querySelector('#cart-drawer-upsell-wrapper');

        if (currentWrapper && newWrapper) {
          currentWrapper.replaceWith(newWrapper);
        }

        await insertSectionCartDrawer();
      } finally {
        setTimeout(() => {
          isUpdating = false;
        }, 100);
      }
    }, 250);
  });

  observer.observe(element, {
    childList: true,
    subtree: true
  });
}

  listenCartDrawer();

  function listenCartPage() {
    const element = document.querySelector('#MainContent .cart__items');
    if (!element) return;

    let timer;

    const observer = new MutationObserver(() => {
      if (timer) clearTimeout(timer);

      timer = setTimeout(async () => {
        const response = await fetch(window.location.href);
        const text = await response.text();
        const newDocument = new DOMParser().parseFromString(text, 'text/html');

        const currentWrapper = document.querySelector('#cart-drawer-upsell-wrapper');
        const newWrapper = newDocument.querySelector('#cart-drawer-upsell-wrapper');

        if (currentWrapper && newWrapper) {
          currentWrapper.replaceWith(newWrapper);
        }

        // insertSectionCartPage();
      }, 250);
    });

    observer.observe(element, {
      attributes: true,
      childList: true,
      subtree: true
    });
  }

  listenCartPage();
})();